import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CpuIcon } from 'lucide-react';
interface SlideLayoutProps {
  children: React.ReactNode;
  className?: string;
  hideLogo?: boolean;
}
export const slideVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.1
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export const itemVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SlideLayout({
  children,
  className = '',
  hideLogo = false
}: SlideLayoutProps) {
  return <motion.div variants={slideVariants} initial="initial" animate="animate" exit="exit" className={`w-full min-h-full flex flex-col items-center justify-center px-8 md:px-16 lg:px-24 py-16 relative ${className}`} data-id="element-498" data-mp="39fft5t4znc8w">
      {/* Persistent logo */}
      {!hideLogo && <div className="absolute top-5 left-6 md:left-8 flex items-center gap-2 z-20 opacity-60" data-id="element-499" data-mp="23ithzq6izfyx">
          <CpuIcon className="w-5 h-5 text-brand-teal" strokeWidth={1.5} data-id="element-500" data-mp="28e8sq998kvr4" />
          <span className="text-sm font-semibold text-brand-text tracking-tight" data-id="element-501" data-mp="2dahh8d9bq1ay">
            Isochron
          </span>
        </div>}
      <div className="w-full max-w-6xl mx-auto relative z-10" data-id="element-502" data-mp="1kmbqn9vl9i37">{children}</div>
    </motion.div>;
}